var Operator = window.Operator || {};
Operator.blockEditors = Operator.blockEditors || {};

$.extend(Operator.blockEditors, {
    HashValuesBrickModel: function(opts) {
        var form = opts.form;
        Operator.Layout.setupCollections(form);
    }
});